{% block sw_order_line_items_grid_column_payload_options %}
    {% parent %}

    {# Cross-sell verification badge — only rendered when this line item
       carries the payload markers CrossSellDiscountCartProcessor sets on
       apply. Sits alongside (never inside) the product title, so it never
       affects storefront/checkout label text — see the processor's own
       docblock for why the title itself is left untouched. #}
    <span
        v-if="item.payload && item.payload.sellopsUcCrossSellDiscount"
        v-tooltip="{ message: $tc('sellops-ultimate-cart.crossSellOrderBadge.tooltip', 0, { percent: item.payload.sellopsUcCrossSellDiscountPercent }) }"
        class="sellops-uc-cross-sell-badge"
    >
        <mt-icon name="regular-tag" size="12px" />
        {{ $tc('sellops-ultimate-cart.crossSellOrderBadge.label', 0, { percent: item.payload.sellopsUcCrossSellDiscountPercent }) }}
    </span>
{% endblock %}
